import { Row, Space } from "@stenajs-webui/core";
import { FlatButton, stenaSms } from "@stenajs-webui/elements";
import { type FC, useEffect } from "react";
import { useDispatch } from "react-redux";

import { UrgentMessageHTMLRenderer } from "../../../common-ui/UrgentMessageHTMLRenderer";
import type { UrgentMessage } from "../../../common/graphql/fragments/gql/UrgentMessage";
import { trackEvent } from "../../../common/tracking/trackerService";
import { showUrgentMessage } from "../../../services/modal/modalActions";
import { markUrgentMessageAsRead } from "../../../services/notifications/notificationsActions";
import { BaseToast } from "./BaseToast";
import { getUrgentMessageIconProps } from "./getBookingResultParams";

export interface UrgentMessageToastContentProps {
  closeToast: () => void;
  urgentMessage: UrgentMessage;
}

const action = "Open urgent message (unread)";

const onPressLink = (url: string) => {
  trackEvent({
    category: "Toast",
    action: "Pressed link in urgent message",
    label: url,
  });
};

export const UrgentMessageToastContent: FC<UrgentMessageToastContentProps> = ({
  urgentMessage,
  closeToast,
}) => {
  const dispatch = useDispatch();

  useEffect(() => {
    trackEvent({ category: "Toast", action: "Appear (urgent message)" });
  }, []);

  const onOpenClick = () => {
    trackEvent({
      category: "Toast",
      action,
    });

    dispatch(showUrgentMessage(urgentMessage, "Toast", action));
    dispatch(markUrgentMessageAsRead(urgentMessage.id));
    closeToast();
  };

  return (
    <BaseToast
      title={urgentMessage.header}
      {...getUrgentMessageIconProps()}
      onClose={closeToast}
    >
      <div
        style={{
          overflowWrap: "break-word",
          display: "-webkit-box",
          WebkitBoxOrient: "vertical",
          WebkitLineClamp: "3",
          overflow: "hidden",
        }}
      >
        <UrgentMessageHTMLRenderer
          html={urgentMessage.textHtml}
          onPressLink={onPressLink}
        />
      </div>
      <Space num={1} />
      <Row alignSelf={"flex-end"}>
        <FlatButton
          label={"Open full message"}
          leftIcon={stenaSms}
          onClick={onOpenClick}
        />
      </Row>
    </BaseToast>
  );
};
